<template>
  <div class="w-full min-w-0 bg-white border border-grayLight rounded-[12px] p-5 flex flex-col overflow-hidden" style="height: 380px;">
    <!-- Header -->
    <div class="flex items-center mb-4">
      <h3 class="text-[14px] font-semibold text-bodyText">Recent Activity</h3>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="flex-1 flex items-center justify-center">
      <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primaryDarkBg"></div>
    </div>

    <!-- Empty state -->
    <div v-else-if="tasks.length === 0" class="flex-1 flex items-center justify-center">
      <p class="text-[13px] text-grayDark">No recent activity.</p>
    </div>

    <!-- Activity list -->
    <div v-else class="flex-1 min-w-0 space-y-3 overflow-y-auto overflow-x-hidden pr-1">
      <div
        v-for="task in tasks"
        :key="task.task_id"
        class="w-full min-w-0 bg-[#F9FAFB] border border-grayLight rounded-[8px] px-4 py-3 cursor-pointer hover:bg-gray-100 transition-colors"
        @click="goToProject(task.project_id)"
      >
        <p class="text-[13px] font-semibold text-bodyText leading-tight truncate">{{ task.title }}</p>
        <p class="text-[12px] text-grayDark mt-0.5 truncate">{{ task.project_name }}</p>
        <div class="flex items-center justify-between mt-1.5 gap-2">
          <span
            class="text-[11px] font-medium"
            :class="statusTextColor(task.task_status)"
          >{{ formatStatus(task.task_status) }}</span>
          <span class="text-[11px] text-grayDark whitespace-nowrap">{{ formatDate(task.updated_at) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/axios';

export default {
  name: 'DashboardRecentActivityCard',
  data() {
    return {
      tasks: [],
      loading: true,
    };
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    },
    formatStatus(status) {
      if (!status) return '';
      return status.replace(/_/g, ' ');
    },
    statusTextColor(status) {
      const s = (status || '').toLowerCase();
      if (s === 'completed') return 'text-green-600';
      if (s === 'inprogress' || s === 'in_progress') return 'text-blue-600';
      if (s === 'overdue') return 'text-red-600';
      if (s === 'review') return 'text-yellow-600';
      return 'text-grayDark';
    },
    goToProject(projectId) {
      this.$router.push({ name: 'ProjectDetails', params: { projectId } });
    },
    async fetchRecentActivities() {
      try {
        this.loading = true;
        const response = await apiClient.get('/web/dashboard/manager/recent-task-activities', {
          params: { limit: 10, offset: 0 },
        });
        this.tasks = response.data.tasks || [];
      } catch (error) {
        console.error('Error fetching recent task activities:', error);
        this.tasks = [];
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.fetchRecentActivities();
  },
};
</script>
